import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isFreeTier } from '../../../../../../shared/subscriptions';
import { window } from '../../../../../globals';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import PaidFeatureGate from '../../../../generic/Gates/PaidFeatureGate';
import { SidebarLayout } from '../../../../layouts';
import Panel from '../shared/components/Settings';
import { useSaveReportSettings } from '../shared/hooks';
import Sidebar from '../Sidebar';
import type { ProjectGroupContext, ReportGenerationParams } from '../../shared/types';

import styles from './ReleaseGroupLevelReport.module.less';

type Props = {
  params: ReportGenerationParams;
};

const ReleaseGroupReportSettings: VoidFunctionComponent<Props> = ({ params }) => {
  const isPaidFeatureGateRestricted = isFreeTier({
    plan: window?.user?.organization?.stripe_plan,
    stripePriceLimit: window?.user?.organization?.stripePriceLimit,
  });
  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext) as ProjectGroupContext;
  const organizationId = window.user?.organization?.id;
  
  const onSave = useSaveReportSettings({
    releaseGroupId: reportContext.groupId,
    organizationId: organizationId!,
  });

  return (
    <div className={styles.settings}>
      <SidebarLayout>
        <SidebarLayout.Main>
          <div className={styles.layout}>
            <Sidebar params={params} resetFormat={_.noop} />
            <PaidFeatureGate isRestricted={isPaidFeatureGateRestricted} hidePill>
              <Panel
                onSave={organizationId ? onSave : async () => {}}
              />
            </PaidFeatureGate>
          </div>
        </SidebarLayout.Main>
      </SidebarLayout>
    </div>
  );
};

export default ReleaseGroupReportSettings;
